// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import ExtraInformationActionType from './extra-information.types';

const INITIAL_STATE = {
	// Extra Information Response
	extraInformationResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** EXTRA INFORMATION ADD START *********************** */
		case ExtraInformationActionType.EXTRA_INFORMATION_ADD_SUCCESS:
			return { ...state, extraInformationResponse: action.payload };

		case ExtraInformationActionType.EXTRA_INFORMATION_ADD_FAILURE:
			return { ...state, extraInformationResponse: action.payload };

		case ExtraInformationActionType.EXTRA_INFORMATION_ADD_RESPONSE_CHANGED:
			return { ...state, extraInformationResponse: null };

		/** ***************** EXTRA INFORMATION ADD END *********************** */

		default:
			return state;
	}
};
